import { parseUtcTimestampMs } from '../../dashboard/utils/date.utils';

/** Shared 2-hour monitoring window used by audit auto-approve and the NAV timer column. */
export const NAV_RECON_AUDIT_AUTO_APPROVE_AFTER_MS = 2 * 60 * 60 * 1000;

export const formatNavReconAutoApproveWindow = () => {
  const hours = NAV_RECON_AUDIT_AUTO_APPROVE_AFTER_MS / (60 * 60 * 1000);
  return `${hours} hour${hours === 1 ? '' : 's'}`;
};

export const formatNavReconDuration = (durationMs: number): string => {
  const totalMinutes = Math.floor(Math.max(0, durationMs) / (60 * 1000));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`;
};

export const formatNavReconElapsedTime = (
  snapshotTimestamp: string | null,
  nowMs: number = Date.now(),
): string => {
  const startMs = parseUtcTimestampMs(snapshotTimestamp);
  if (startMs == null) return 'Unknown';

  const elapsedMs = Math.max(0, nowMs - startMs);
  const totalMinutes = Math.floor(elapsedMs / (60 * 1000));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) return `${minutes} minute${minutes === 1 ? '' : 's'}`;
  return `${hours} hour${hours === 1 ? '' : 's'} ${minutes} minute${
    minutes === 1 ? '' : 's'
  }`;
};

export type NavReconTimerState = {
  startMs: number;
  elapsedMs: number;
  remainingMs: number;
  isOverdue: boolean;
};

export const getNavReconTimerState = (
  snapshotTimestamp: string | null | undefined,
  nowMs: number = Date.now(),
): NavReconTimerState | null => {
  const startMs = parseUtcTimestampMs(snapshotTimestamp);
  if (startMs == null) return null;

  const elapsedMs = Math.max(0, nowMs - startMs);
  const remainingMs = NAV_RECON_AUDIT_AUTO_APPROVE_AFTER_MS - elapsedMs;

  return {
    startMs,
    elapsedMs,
    remainingMs,
    isOverdue: remainingMs <= 0,
  };
};
